/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import { getAuthorizationHeader } from 'utils/Helpers'
import InboxStatusEnum from 'constants/InboxStatusEnum'
import * as ResourcesConstants from 'constants/ResourcesConstants'
import { RequestContentType } from 'utils/Helpers'
import { serializeObject } from 'utils/Helpers'

const InboxAPI = Marty.createStateSource({
  id: 'InboxAPI',
  type: 'http',
  baseUrl: ResourcesConstants.CONVERSATION_API,

  fetchInboxes() {
    return this.get({
      url: '/inboxes',
      headers: getAuthorizationHeader()
    })
  },

  checkInboxExistsForEmail(email) {
    const queryParams = serializeObject({ address: email })
    return this.get({
      url: `/inboxes?${ queryParams }`,
      headers: getAuthorizationHeader()
    })
  },

  fetchInbox(inboxId) {
    return this.get({
      url: `/inboxes/${ inboxId }`,
      headers: getAuthorizationHeader()
    })
  },

  updateInbox(inboxId, params) {
    return this.patch({
      url: `/inboxes/${ inboxId }`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify(params)
    })
  },

  createInbox(params) {
    return this.post({
      url: '/inboxes',
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify(params)
    })
  },

  archiveInbox(inboxId) {
    return this.patch({
      url: `/inboxes/${ inboxId }`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify({ status: InboxStatusEnum.ARCHIVED.key })
    })
  },

  fetchInboxMetrics(inboxId, startDate, endDate) {
    const queryParams = serializeObject({
      startDate,
      endDate
    })
    return this.get({
      url: `/inboxes/${ inboxId }/metrics?${ queryParams }`,
      headers: getAuthorizationHeader()
    })
  },

  fetchWhiteListLabels(domain) {
    return this.get({
      url: `/whitelabels/${ domain }`,
      headers: getAuthorizationHeader()
    })
  },

  validateWhiteListLabels(domain) {
    return this.post({
      url: `/whitelabels/${ domain }/validate`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON
    })
  },

  createWhiteLabelConfiguration(domain) {
    return this.post({
      url: `/whitelabels/${ domain }`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON
    })
  }
})

export default InboxAPI




// WEBPACK FOOTER //
// ./src/scripts/sources/InboxAPI.js